import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {OpencvService} from '../../../../services/opencv/opencv.service';
import {CameraService} from '../../../../services/camera/camera.service';
import {interval} from 'rxjs';

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['../../../../app.component.scss', './camera.component.scss']
})
export class CameraComponent implements OnInit, AfterViewInit, OnDestroy {
  intervalCheck: any;

  constructor(public opencvService: OpencvService,
              public cameraService: CameraService) {
  }

  ngOnInit() {
    const canvasImage = document.getElementById('canvasLocalOutputOpencv') as HTMLCanvasElement;
    const videoElement = document.getElementById('localVideoElementOpencv') as HTMLVideoElement;
    this.cameraService.initVideoElement(videoElement);
    this.opencvService.setVariables(videoElement, canvasImage);
  }

  startInterval() {
    this.stopInterval();
    this.intervalCheck = interval(1000)
      .subscribe(() => {
        if (this.opencvService.classifiersLoadFinished) {
          this.stopInterval();
          this.opencvService.videoDetection();
        }
      });
  }

  stopInterval() {
    if (this.intervalCheck) {
      this.intervalCheck.unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    this.cameraService.startCamera(() => {
      this.startInterval();
    });
  }

  ngOnDestroy() {
    this.stopInterval();
    this.cameraService.stopCamera();
    this.opencvService.stopVideoDetection();
  }
}
